import { makeStyles } from 'tss-react/mui'
import { lato } from '@styles/fonts'
import { nunito_sans } from '@styles/fonts'
import Noise from 'src/assets/images/campaigns/noise.png'

const useStyles = makeStyles()((theme) => ({
  outerContainer: {
    height: 'auto',
    textAlign: 'center',
    background: `url(${Noise.src}) white`,
  },

  innerContainer: {
    maxWidth: theme.maxWidth,
    margin: 'auto',
  },

  accordianContainer: {
    width: '70%',
    margin: 'auto',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      padding: theme.spacing(0, 4),
    },
  },
  accordian: {
    background: '#FFFFFF',
    borderRadius: '8px',
    padding: theme.spacing(1, 5, 2.5),
    marginBottom: theme.spacing(4),
    ':before': {
      height: '0 !important',
    },
  },
  title: {
    fontFamily: nunito_sans.style.fontFamily,
    fontStyle: 'normal',
    fontWeight: 800,
    fontSize: '18px',
    lineHeight: '25px',
    textTransform: 'uppercase',
    color: theme.custom.blackColor,
    textAlign: 'start',
    paddingRight: theme.spacing(2),
    [theme.breakpoints.down('md')]: {},
  },
  desc: {
    fontFamily: lato.style.fontFamily,
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '16px',
    textAlign: 'start',
    lineHeight: '23px',
    color: theme.custom.blackColor,
    opacity: '.8',
    padding: 0,
    margin: 0,
    p: {
      padding: 0,
      margin: 0,
    },
    a: {
      color: theme.custom.blackColor,
    },
  },
  upperGradient: {
    height: '158px',
    background:
      'linear-gradient(180deg, #FFFFFF 39.42%, rgba(255, 255, 255, 0) 100%)',
    [theme.breakpoints.down('md')]: {
      height: '100px',
    },
  },
  lowerGradient: {
    height: '158px',
    transform: 'rotate(-180deg)',
    background:
      'linear-gradient(180deg, #FFFFFF 39.42%, rgba(255, 255, 255, 0) 100%)',
    [theme.breakpoints.down('md')]: {
      height: '100px',
    },
  },
}))

export default useStyles
